export default [
  {
    "Stadtteilnummer": "1",
    "Stadtteil": "Altstadt",
    "Wahlberechtigte insgesamt": "2702",
    "Wähler/innen": "1051",
    "Wähler/innen in %": "38,9",
    "darunter Wähler mit Wahlschein": "333",
    "darunter Wähler mit Wahlschein in %": "31,7",
    "gültige Stimmen": "89031",
    "CDU": "19442",
    "CDU in %": "21,8",
    "SPD": "20706",
    "SPD in %": "23,3",
    "GRÜNE": "12540",
    "GRÜNE in %": "14,1",
    "DIE LINKE": "7506",
    "DIE LINKE in %": "8,4",
    "FDP": "7716",
    "FDP in %": "8,7",
    "BFF": "3640",
    "BFF in %": "4,1",
    "PIRATEN": "484",
    "PIRATEN in %": "0,5",
    "ÖkoLinX-ARL": "2210",
    "ÖkoLinX-ARL in %": "2,5",
    "ELF": "1323",
    "ELF in %": "1,5",
    "REP": "168",
    "REP in %": "0,2",
    "Graue Panther": "350",
    "Graue Panther in %": "0,4",
    "ALFA": "490",
    "ALFA in %": "0,6",
    "IBF": "1186",
    "IBF in %": "1,3",
    "Liberale": "804",
    "Liberale in %": "0,9",
    "P.O.P.": "104",
    "P.O.P. in %": "0,1",
    "FREIE WÄHLER": "512",
    "FREIE WÄHLER in %": "0,6",
    "AfD": "7914",
    "AfD in %": "8,9",
    "NPD": "84",
    "NPD in %": "0,1",
    "DIE PARTEI": "1218",
    "DIE PARTEI in %": "1,4",
    "dFfm": "634",
    "dFfm in %": "0,7"
  },
  {
    "Stadtteilnummer": "2",
    "Stadtteil": "Innenstadt",
    "Wahlberechtigte insgesamt": "4476",
    "Wähler/innen": "1118",
    "Wähler/innen in %": "25",
    "darunter Wähler mit Wahlschein": "346",
    "darunter Wähler mit Wahlschein in %": "30,9",
    "gültige Stimmen": "96181",
    "CDU": "22247",
    "CDU in %": "23,1",
    "SPD": "18380",
    "SPD in %": "19,1",
    "GRÜNE": "16702",
    "GRÜNE in %": "17,4",
    "DIE LINKE": "8754",
    "DIE LINKE in %": "9,1",
    "FDP": "7713",
    "FDP in %": "8",
    "BFF": "2355",
    "BFF in %": "2,4",
    "PIRATEN": "1189",
    "PIRATEN in %": "1,2",
    "ÖkoLinX-ARL": "2348",
    "ÖkoLinX-ARL in %": "2,4",
    "ELF": "3264",
    "ELF in %": "3,4",
    "REP": "408",
    "REP in %": "0,4",
    "Graue Panther": "280",
    "Graue Panther in %": "0,3",
    "ALFA": "460",
    "ALFA in %": "0,5",
    "IBF": "554",
    "IBF in %": "0,6",
    "Liberale": "693",
    "Liberale in %": "0,7",
    "P.O.P.": "290",
    "P.O.P. in %": "0,3",
    "FREIE WÄHLER": "400",
    "FREIE WÄHLER in %": "0,4",
    "AfD": "7886",
    "AfD in %": "8,2",
    "NPD": "300",
    "NPD in %": "0,3",
    "DIE PARTEI": "1577",
    "DIE PARTEI in %": "1,6",
    "dFfm": "381",
    "dFfm in %": "0,4"
  },
  {
    "Stadtteilnummer": "4",
    "Stadtteil": "Westend-Süd",
    "Wahlberechtigte insgesamt": "13160",
    "Wähler/innen": "5661",
    "Wähler/innen in %": "43",
    "darunter Wähler mit Wahlschein": "1824",
    "darunter Wähler mit Wahlschein in %": "32,2",
    "gültige Stimmen": "498890",
    "CDU": "167895",
    "CDU in %": "33,7",
    "SPD": "85511",
    "SPD in %": "17,1",
    "GRÜNE": "72859",
    "GRÜNE in %": "14,6",
    "DIE LINKE": "26462",
    "DIE LINKE in %": "5,3",
    "FDP": "75484",
    "FDP in %": "15,1",
    "BFF": "9975",
    "BFF in %": "2",
    "PIRATEN": "2944",
    "PIRATEN in %": "0,6",
    "ÖkoLinX-ARL": "6569",
    "ÖkoLinX-ARL in %": "1,3",
    "ELF": "3542",
    "ELF in %": "0,7",
    "REP": "190",
    "REP in %": "0",
    "Graue Panther": "1405",
    "Graue Panther in %": "0,3",
    "ALFA": "2924",
    "ALFA in %": "0,6",
    "IBF": "935",
    "IBF in %": "0,2",
    "Liberale": "1879",
    "Liberale in %": "0,4",
    "P.O.P.": "957",
    "P.O.P. in %": "0,2",
    "FREIE WÄHLER": "847",
    "FREIE WÄHLER in %": "0,2",
    "AfD": "33076",
    "AfD in %": "6,6",
    "NPD": "261",
    "NPD in %": "0,1",
    "DIE PARTEI": "4345",
    "DIE PARTEI in %": "0,9",
    "dFfm": "830",
    "dFfm in %": "0,2"
  },
  {
    "Stadtteilnummer": "5",
    "Stadtteil": "Westend-Nord",
    "Wahlberechtigte insgesamt": "6743",
    "Wähler/innen": "2701",
    "Wähler/innen in %": "40,1",
    "darunter Wähler mit Wahlschein": "829",
    "darunter Wähler mit Wahlschein in %": "30,7",
    "gültige Stimmen": "238276",
    "CDU": "68807",
    "CDU in %": "28,9",
    "SPD": "49043",
    "SPD in %": "20,6",
    "GRÜNE": "37050",
    "GRÜNE in %": "15,5",
    "DIE LINKE": "13533",
    "DIE LINKE in %": "5,7",
    "FDP": "32905",
    "FDP in %": "13,8",
    "BFF": "4006",
    "BFF in %": "1,7",
    "PIRATEN": "1880",
    "PIRATEN in %": "0,8",
    "ÖkoLinX-ARL": "5607",
    "ÖkoLinX-ARL in %": "2,4",
    "ELF": "1887",
    "ELF in %": "0,8",
    "REP": "302",
    "REP in %": "0,1",
    "Graue Panther": "763",
    "Graue Panther in %": "0,3",
    "ALFA": "942",
    "ALFA in %": "0,4",
    "IBF": "996",
    "IBF in %": "0,4",
    "Liberale": "654",
    "Liberale in %": "0,3",
    "P.O.P.": "858",
    "P.O.P. in %": "0,4",
    "FREIE WÄHLER": "822",
    "FREIE WÄHLER in %": "0,3",
    "AfD": "13370",
    "AfD in %": "5,6",
    "NPD": "489",
    "NPD in %": "0,2",
    "DIE PARTEI": "3509",
    "DIE PARTEI in %": "1,5",
    "dFfm": "853",
    "dFfm in %": "0,4"
  },
  {
    "Stadtteilnummer": "6",
    "Stadtteil": "Nordend-West",
    "Wahlberechtigte insgesamt": "22949",
    "Wähler/innen": "10855",
    "Wähler/innen in %": "47,3",
    "darunter Wähler mit Wahlschein": "2865",
    "darunter Wähler mit Wahlschein in %": "26,4",
    "gültige Stimmen": "960751",
    "CDU": "215612",
    "CDU in %": "22,4",
    "SPD": "202369",
    "SPD in %": "21,1",
    "GRÜNE": "207211",
    "GRÜNE in %": "21,6",
    "DIE LINKE": "79295",
    "DIE LINKE in %": "8,3",
    "FDP": "93488",
    "FDP in %": "9,7",
    "BFF": "16164",
    "BFF in %": "1,7",
    "PIRATEN": "8504",
    "PIRATEN in %": "0,9",
    "ÖkoLinX-ARL": "40731",
    "ÖkoLinX-ARL in %": "4,2",
    "ELF": "5103",
    "ELF in %": "0,5",
    "REP": "793",
    "REP in %": "0,1",
    "Graue Panther": "2009",
    "Graue Panther in %": "0,2",
    "ALFA": "3243",
    "ALFA in %": "0,3",
    "IBF": "4115",
    "IBF in %": "0,4",
    "Liberale": "4235",
    "Liberale in %": "0,4",
    "P.O.P.": "3773",
    "P.O.P. in %": "0,4",
    "FREIE WÄHLER": "1711",
    "FREIE WÄHLER in %": "0,2",
    "AfD": "49097",
    "AfD in %": "5,1",
    "NPD": "1046",
    "NPD in %": "0,1",
    "DIE PARTEI": "16120",
    "DIE PARTEI in %": "1,7",
    "dFfm": "6132",
    "dFfm in %": "0,6"
  },
  {
    "Stadtteilnummer": "7",
    "Stadtteil": "Nordend-Ost",
    "Wahlberechtigte insgesamt": "17670",
    "Wähler/innen": "8185",
    "Wähler/innen in %": "46,3",
    "darunter Wähler mit Wahlschein": "1887",
    "darunter Wähler mit Wahlschein in %": "23,1",
    "gültige Stimmen": "716643",
    "CDU": "112992",
    "CDU in %": "15,8",
    "SPD": "163751",
    "SPD in %": "22,8",
    "GRÜNE": "178353",
    "GRÜNE in %": "24,9",
    "DIE LINKE": "91357",
    "DIE LINKE in %": "12,7",
    "FDP": "40889",
    "FDP in %": "5,7",
    "BFF": "10550",
    "BFF in %": "1,5",
    "PIRATEN": "6417",
    "PIRATEN in %": "0,9",
    "ÖkoLinX-ARL": "38920",
    "ÖkoLinX-ARL in %": "5,4",
    "ELF": "4190",
    "ELF in %": "0,6",
    "REP": "288",
    "REP in %": "0",
    "Graue Panther": "3082",
    "Graue Panther in %": "0,4",
    "ALFA": "2258",
    "ALFA in %": "0,3",
    "IBF": "1478",
    "IBF in %": "0,2",
    "Liberale": "4140",
    "Liberale in %": "0,6",
    "P.O.P.": "3214",
    "P.O.P. in %": "0,4",
    "FREIE WÄHLER": "2953",
    "FREIE WÄHLER in %": "0,4",
    "AfD": "30340",
    "AfD in %": "4,2",
    "NPD": "298",
    "NPD in %": "0",
    "DIE PARTEI": "12993",
    "DIE PARTEI in %": "1,8",
    "dFfm": "8180",
    "dFfm in %": "1,1"
  },
  {
    "Stadtteilnummer": "8",
    "Stadtteil": "Ostend",
    "Wahlberechtigte insgesamt": "20330",
    "Wähler/innen": "8315",
    "Wähler/innen in %": "40,9",
    "darunter Wähler mit Wahlschein": "2147",
    "darunter Wähler mit Wahlschein in %": "25,8",
    "gültige Stimmen": "728340",
    "CDU": "147434",
    "CDU in %": "20,2",
    "SPD": "180696",
    "SPD in %": "24,8",
    "GRÜNE": "141398",
    "GRÜNE in %": "19,4",
    "DIE LINKE": "69811",
    "DIE LINKE in %": "9,6",
    "FDP": "45733",
    "FDP in %": "6,3",
    "BFF": "12453",
    "BFF in %": "1,7",
    "PIRATEN": "7428",
    "PIRATEN in %": "1",
    "ÖkoLinX-ARL": "22894",
    "ÖkoLinX-ARL in %": "3,1",
    "ELF": "6293",
    "ELF in %": "0,9",
    "REP": "915",
    "REP in %": "0,1",
    "Graue Panther": "3576",
    "Graue Panther in %": "0,5",
    "ALFA": "2830",
    "ALFA in %": "0,4",
    "IBF": "2652",
    "IBF in %": "0,4",
    "Liberale": "2832",
    "Liberale in %": "0,4",
    "P.O.P.": "5096",
    "P.O.P. in %": "0,7",
    "FREIE WÄHLER": "3814",
    "FREIE WÄHLER in %": "0,5",
    "AfD": "47792",
    "AfD in %": "6,6",
    "NPD": "1441",
    "NPD in %": "0,2",
    "DIE PARTEI": "14151",
    "DIE PARTEI in %": "1,9",
    "dFfm": "9101",
    "dFfm in %": "1,2"
  },
  {
    "Stadtteilnummer": "9",
    "Stadtteil": "Bornheim",
    "Wahlberechtigte insgesamt": "22425",
    "Wähler/innen": "9756",
    "Wähler/innen in %": "43,5",
    "darunter Wähler mit Wahlschein": "2440",
    "darunter Wähler mit Wahlschein in %": "25",
    "gültige Stimmen": "843478",
    "CDU": "142384",
    "CDU in %": "16,9",
    "SPD": "225667",
    "SPD in %": "26,8",
    "GRÜNE": "161424",
    "GRÜNE in %": "19,1",
    "DIE LINKE": "90450",
    "DIE LINKE in %": "10,7",
    "FDP": "40057",
    "FDP in %": "4,7",
    "BFF": "12616",
    "BFF in %": "1,5",
    "PIRATEN": "7176",
    "PIRATEN in %": "0,9",
    "ÖkoLinX-ARL": "28453",
    "ÖkoLinX-ARL in %": "3,4",
    "ELF": "9599",
    "ELF in %": "1,1",
    "REP": "1039",
    "REP in %": "0,1",
    "Graue Panther": "5132",
    "Graue Panther in %": "0,6",
    "ALFA": "3206",
    "ALFA in %": "0,4",
    "IBF": "3462",
    "IBF in %": "0,4",
    "Liberale": "2603",
    "Liberale in %": "0,3",
    "P.O.P.": "4201",
    "P.O.P. in %": "0,5",
    "FREIE WÄHLER": "6489",
    "FREIE WÄHLER in %": "0,8",
    "AfD": "55405",
    "AfD in %": "6,6",
    "NPD": "1396",
    "NPD in %": "0,2",
    "DIE PARTEI": "15900",
    "DIE PARTEI in %": "1,9",
    "dFfm": "26819",
    "dFfm in %": "3,2"
  },
  {
    "Stadtteilnummer": "10",
    "Stadtteil": "Gutleut-/Bahnhofsviertel",
    "Wahlberechtigte insgesamt": "7013",
    "Wähler/innen": "2147",
    "Wähler/innen in %": "30,6",
    "darunter Wähler mit Wahlschein": "521",
    "darunter Wähler mit Wahlschein in %": "24,3",
    "gültige Stimmen": "182466",
    "CDU": "32661",
    "CDU in %": "17,9",
    "SPD": "36719",
    "SPD in %": "20,1",
    "GRÜNE": "34320",
    "GRÜNE in %": "18,8",
    "DIE LINKE": "20746",
    "DIE LINKE in %": "11,4",
    "FDP": "14807",
    "FDP in %": "8,1",
    "BFF": "3463",
    "BFF in %": "1,9",
    "PIRATEN": "1568",
    "PIRATEN in %": "0,9",
    "ÖkoLinX-ARL": "9653",
    "ÖkoLinX-ARL in %": "5,3",
    "ELF": "2459",
    "ELF in %": "1,3",
    "REP": "316",
    "REP in %": "0,2",
    "Graue Panther": "726",
    "Graue Panther in %": "0,4",
    "ALFA": "555",
    "ALFA in %": "0,3",
    "IBF": "1292",
    "IBF in %": "0,7",
    "Liberale": "1190",
    "Liberale in %": "0,7",
    "P.O.P.": "847",
    "P.O.P. in %": "0,5",
    "FREIE WÄHLER": "932",
    "FREIE WÄHLER in %": "0,5",
    "AfD": "12714",
    "AfD in %": "7",
    "NPD": "284",
    "NPD in %": "0,2",
    "DIE PARTEI": "6453",
    "DIE PARTEI in %": "3,5",
    "dFfm": "761",
    "dFfm in %": "0,4"
  },
  {
    "Stadtteilnummer": "11",
    "Stadtteil": "Gallus",
    "Wahlberechtigte insgesamt": "22411",
    "Wähler/innen": "6148",
    "Wähler/innen in %": "27,4",
    "darunter Wähler mit Wahlschein": "1588",
    "darunter Wähler mit Wahlschein in %": "25,8",
    "gültige Stimmen": "529404",
    "CDU": "104404",
    "CDU in %": "19,7",
    "SPD": "115440",
    "SPD in %": "21,8",
    "GRÜNE": "81399",
    "GRÜNE in %": "15,4",
    "DIE LINKE": "55106",
    "DIE LINKE in %": "10,4",
    "FDP": "38872",
    "FDP in %": "7,3",
    "BFF": "12104",
    "BFF in %": "2,3",
    "PIRATEN": "6797",
    "PIRATEN in %": "1,3",
    "ÖkoLinX-ARL": "16624",
    "ÖkoLinX-ARL in %": "3,1",
    "ELF": "9411",
    "ELF in %": "1,8",
    "REP": "1833",
    "REP in %": "0,3",
    "Graue Panther": "2777",
    "Graue Panther in %": "0,5",
    "ALFA": "2064",
    "ALFA in %": "0,4",
    "IBF": "3437",
    "IBF in %": "0,6",
    "Liberale": "2770",
    "Liberale in %": "0,5",
    "P.O.P.": "1501",
    "P.O.P. in %": "0,3",
    "FREIE WÄHLER": "1801",
    "FREIE WÄHLER in %": "0,3",
    "AfD": "57240",
    "AfD in %": "10,8",
    "NPD": "1835",
    "NPD in %": "0,3",
    "DIE PARTEI": "10453",
    "DIE PARTEI in %": "2",
    "dFfm": "3536",
    "dFfm in %": "0,7"
  },
  {
    "Stadtteilnummer": "12",
    "Stadtteil": "Bockenheim",
    "Wahlberechtigte insgesamt": "27017",
    "Wähler/innen": "10378",
    "Wähler/innen in %": "38,4",
    "darunter Wähler mit Wahlschein": "2571",
    "darunter Wähler mit Wahlschein in %": "24,8",
    "gültige Stimmen": "909893",
    "CDU": "172964",
    "CDU in %": "19",
    "SPD": "215617",
    "SPD in %": "23,7",
    "GRÜNE": "182992",
    "GRÜNE in %": "20,1",
    "DIE LINKE": "98744",
    "DIE LINKE in %": "10,9",
    "FDP": "68322",
    "FDP in %": "7,5",
    "BFF": "18572",
    "BFF in %": "2",
    "PIRATEN": "10520",
    "PIRATEN in %": "1,2",
    "ÖkoLinX-ARL": "29869",
    "ÖkoLinX-ARL in %": "3,3",
    "ELF": "11149",
    "ELF in %": "1,2",
    "REP": "1516",
    "REP in %": "0,2",
    "Graue Panther": "4195",
    "Graue Panther in %": "0,5",
    "ALFA": "4566",
    "ALFA in %": "0,5",
    "IBF": "3095",
    "IBF in %": "0,3",
    "Liberale": "4092",
    "Liberale in %": "0,4",
    "P.O.P.": "2210",
    "P.O.P. in %": "0,2",
    "FREIE WÄHLER": "2528",
    "FREIE WÄHLER in %": "0,3",
    "AfD": "55242",
    "AfD in %": "6,1",
    "NPD": "1598",
    "NPD in %": "0,2",
    "DIE PARTEI": "17415",
    "DIE PARTEI in %": "1,9",
    "dFfm": "4687",
    "dFfm in %": "0,5"
  },
  {
    "Stadtteilnummer": "13",
    "Stadtteil": "Sachsenhausen-Nord",
    "Wahlberechtigte insgesamt": "23458",
    "Wähler/innen": "9922",
    "Wähler/innen in %": "42,3",
    "darunter Wähler mit Wahlschein": "2675",
    "darunter Wähler mit Wahlschein in %": "27",
    "gültige Stimmen": "870967",
    "CDU": "210574",
    "CDU in %": "24,2",
    "SPD": "185761",
    "SPD in %": "21,3",
    "GRÜNE": "171572",
    "GRÜNE in %": "19,7",
    "DIE LINKE": "64964",
    "DIE LINKE in %": "7,5",
    "FDP": "94714",
    "FDP in %": "10,9",
    "BFF": "19745",
    "BFF in %": "2,3",
    "PIRATEN": "6135",
    "PIRATEN in %": "0,7",
    "ÖkoLinX-ARL": "15645",
    "ÖkoLinX-ARL in %": "1,8",
    "ELF": "5385",
    "ELF in %": "0,6",
    "REP": "959",
    "REP in %": "0,1",
    "Graue Panther": "5115",
    "Graue Panther in %": "0,6",
    "ALFA": "4005",
    "ALFA in %": "0,5",
    "IBF": "2640",
    "IBF in %": "0,3",
    "Liberale": "3680",
    "Liberale in %": "0,4",
    "P.O.P.": "3429",
    "P.O.P. in %": "0,4",
    "FREIE WÄHLER": "3532",
    "FREIE WÄHLER in %": "0,4",
    "AfD": "55572",
    "AfD in %": "6,4",
    "NPD": "1000",
    "NPD in %": "0,1",
    "DIE PARTEI": "11549",
    "DIE PARTEI in %": "1,3",
    "dFfm": "4991",
    "dFfm in %": "0,6"
  },
  {
    "Stadtteilnummer": "14",
    "Stadtteil": "Sachsenhausen-Süd",
    "Wahlberechtigte insgesamt": "20275",
    "Wähler/innen": "8523",
    "Wähler/innen in %": "42",
    "darunter Wähler mit Wahlschein": "2906",
    "darunter Wähler mit Wahlschein in %": "34,1",
    "gültige Stimmen": "738742",
    "CDU": "188407",
    "CDU in %": "25,5",
    "SPD": "183531",
    "SPD in %": "24,8",
    "GRÜNE": "99135",
    "GRÜNE in %": "13,4",
    "DIE LINKE": "51165",
    "DIE LINKE in %": "6,9",
    "FDP": "74898",
    "FDP in %": "10,1",
    "BFF": "23306",
    "BFF in %": "3,2",
    "PIRATEN": "6311",
    "PIRATEN in %": "0,9",
    "ÖkoLinX-ARL": "8531",
    "ÖkoLinX-ARL in %": "1,2",
    "ELF": "3891",
    "ELF in %": "0,5",
    "REP": "1286",
    "REP in %": "0,2",
    "Graue Panther": "5967",
    "Graue Panther in %": "0,8",
    "ALFA": "4919",
    "ALFA in %": "0,7",
    "IBF": "2280",
    "IBF in %": "0,3",
    "Liberale": "1697",
    "Liberale in %": "0,2",
    "P.O.P.": "2722",
    "P.O.P. in %": "0,4",
    "FREIE WÄHLER": "2652",
    "FREIE WÄHLER in %": "0,4",
    "AfD": "63850",
    "AfD in %": "8,6",
    "NPD": "1693",
    "NPD in %": "0,2",
    "DIE PARTEI": "7674",
    "DIE PARTEI in %": "1",
    "dFfm": "4827",
    "dFfm in %": "0,7"
  },
  {
    "Stadtteilnummer": "16",
    "Stadtteil": "Oberrad",
    "Wahlberechtigte insgesamt": "9215",
    "Wähler/innen": "3348",
    "Wähler/innen in %": "36,3",
    "darunter Wähler mit Wahlschein": "919",
    "darunter Wähler mit Wahlschein in %": "27,4",
    "gültige Stimmen": "282242",
    "CDU": "78905",
    "CDU in %": "28",
    "SPD": "67944",
    "SPD in %": "24,1",
    "GRÜNE": "33350",
    "GRÜNE in %": "11,8",
    "DIE LINKE": "19627",
    "DIE LINKE in %": "7",
    "FDP": "16364",
    "FDP in %": "5,8",
    "BFF": "7631",
    "BFF in %": "2,7",
    "PIRATEN": "2315",
    "PIRATEN in %": "0,8",
    "ÖkoLinX-ARL": "4311",
    "ÖkoLinX-ARL in %": "1,5",
    "ELF": "2866",
    "ELF in %": "1",
    "REP": "1609",
    "REP in %": "0,6",
    "Graue Panther": "3527",
    "Graue Panther in %": "1,2",
    "ALFA": "803",
    "ALFA in %": "0,3",
    "IBF": "404",
    "IBF in %": "0,1",
    "Liberale": "346",
    "Liberale in %": "0,1",
    "P.O.P.": "1107",
    "P.O.P. in %": "0,4",
    "FREIE WÄHLER": "1087",
    "FREIE WÄHLER in %": "0,4",
    "AfD": "34359",
    "AfD in %": "12,2",
    "NPD": "893",
    "NPD in %": "0,3",
    "DIE PARTEI": "3720",
    "DIE PARTEI in %": "1,3",
    "dFfm": "1074",
    "dFfm in %": "0,4"
  },
  {
    "Stadtteilnummer": "17",
    "Stadtteil": "Niederrad",
    "Wahlberechtigte insgesamt": "16743",
    "Wähler/innen": "5635",
    "Wähler/innen in %": "33,7",
    "darunter Wähler mit Wahlschein": "1523",
    "darunter Wähler mit Wahlschein in %": "27",
    "gültige Stimmen": "482337",
    "CDU": "108445",
    "CDU in %": "22,5",
    "SPD": "124650",
    "SPD in %": "25,8",
    "GRÜNE": "54986",
    "GRÜNE in %": "11,4",
    "DIE LINKE": "38250",
    "DIE LINKE in %": "7,9",
    "FDP": "32487",
    "FDP in %": "6,7",
    "BFF": "35176",
    "BFF in %": "7,3",
    "PIRATEN": "4186",
    "PIRATEN in %": "0,9",
    "ÖkoLinX-ARL": "4872",
    "ÖkoLinX-ARL in %": "1",
    "ELF": "4731",
    "ELF in %": "1",
    "REP": "1545",
    "REP in %": "0,3",
    "Graue Panther": "3513",
    "Graue Panther in %": "0,7",
    "ALFA": "1908",
    "ALFA in %": "0,4",
    "IBF": "2094",
    "IBF in %": "0,4",
    "Liberale": "912",
    "Liberale in %": "0,2",
    "P.O.P.": "996",
    "P.O.P. in %": "0,2",
    "FREIE WÄHLER": "3020",
    "FREIE WÄHLER in %": "0,6",
    "AfD": "48421",
    "AfD in %": "10",
    "NPD": "1780",
    "NPD in %": "0,4",
    "DIE PARTEI": "6526",
    "DIE PARTEI in %": "1,4",
    "dFfm": "3839",
    "dFfm in %": "0,8"
  },
  {
    "Stadtteilnummer": "18",
    "Stadtteil": "Schwanheim",
    "Wahlberechtigte insgesamt": "14008",
    "Wähler/innen": "5319",
    "Wähler/innen in %": "38",
    "darunter Wähler mit Wahlschein": "1290",
    "darunter Wähler mit Wahlschein in %": "24,3",
    "gültige Stimmen": "452460",
    "CDU": "126464",
    "CDU in %": "28",
    "SPD": "117312",
    "SPD in %": "25,9",
    "GRÜNE": "45140",
    "GRÜNE in %": "10",
    "DIE LINKE": "20725",
    "DIE LINKE in %": "4,6",
    "FDP": "25968",
    "FDP in %": "5,7",
    "BFF": "19651",
    "BFF in %": "4,3",
    "PIRATEN": "2876",
    "PIRATEN in %": "0,6",
    "ÖkoLinX-ARL": "2304",
    "ÖkoLinX-ARL in %": "0,5",
    "ELF": "3839",
    "ELF in %": "0,8",
    "REP": "3176",
    "REP in %": "0,7",
    "Graue Panther": "5385",
    "Graue Panther in %": "1,2",
    "ALFA": "1382",
    "ALFA in %": "0,3",
    "IBF": "2823",
    "IBF in %": "0,6",
    "Liberale": "484",
    "Liberale in %": "0,1",
    "P.O.P.": "1836",
    "P.O.P. in %": "0,4",
    "FREIE WÄHLER": "3047",
    "FREIE WÄHLER in %": "0,7",
    "AfD": "60558",
    "AfD in %": "13,4",
    "NPD": "2070",
    "NPD in %": "0,5",
    "DIE PARTEI": "4377",
    "DIE PARTEI in %": "1",
    "dFfm": "3043",
    "dFfm in %": "0,7"
  },
  {
    "Stadtteilnummer": "19",
    "Stadtteil": "Griesheim",
    "Wahlberechtigte insgesamt": "15049",
    "Wähler/innen": "3869",
    "Wähler/innen in %": "25,7",
    "darunter Wähler mit Wahlschein": "917",
    "darunter Wähler mit Wahlschein in %": "23,7",
    "gültige Stimmen": "321802",
    "CDU": "70952",
    "CDU in %": "22",
    "SPD": "87808",
    "SPD in %": "27,3",
    "GRÜNE": "34152",
    "GRÜNE in %": "10,6",
    "DIE LINKE": "18856",
    "DIE LINKE in %": "5,9",
    "FDP": "16485",
    "FDP in %": "5,1",
    "BFF": "7600",
    "BFF in %": "2,4",
    "PIRATEN": "3096",
    "PIRATEN in %": "1",
    "ÖkoLinX-ARL": "3698",
    "ÖkoLinX-ARL in %": "1,1",
    "ELF": "12414",
    "ELF in %": "3,9",
    "REP": "2368",
    "REP in %": "0,7",
    "Graue Panther": "2059",
    "Graue Panther in %": "0,6",
    "ALFA": "732",
    "ALFA in %": "0,2",
    "IBF": "2085",
    "IBF in %": "0,6",
    "Liberale": "463",
    "Liberale in %": "0,1",
    "P.O.P.": "948",
    "P.O.P. in %": "0,3",
    "FREIE WÄHLER": "4251",
    "FREIE WÄHLER in %": "1,3",
    "AfD": "44663",
    "AfD in %": "13,9",
    "NPD": "3071",
    "NPD in %": "1",
    "DIE PARTEI": "4243",
    "DIE PARTEI in %": "1,3",
    "dFfm": "1858",
    "dFfm in %": "0,6"
  },
  {
    "Stadtteilnummer": "20",
    "Stadtteil": "Rödelheim",
    "Wahlberechtigte insgesamt": "12359",
    "Wähler/innen": "4644",
    "Wähler/innen in %": "37,6",
    "darunter Wähler mit Wahlschein": "1045",
    "darunter Wähler mit Wahlschein in %": "22,5",
    "gültige Stimmen": "398695",
    "CDU": "78047",
    "CDU in %": "19,6",
    "SPD": "89373",
    "SPD in %": "22,4",
    "GRÜNE": "54543",
    "GRÜNE in %": "13,7",
    "DIE LINKE": "48152",
    "DIE LINKE in %": "12,1",
    "FDP": "27385",
    "FDP in %": "6,9",
    "BFF": "7976",
    "BFF in %": "2",
    "PIRATEN": "5060",
    "PIRATEN in %": "1,3",
    "ÖkoLinX-ARL": "16411",
    "ÖkoLinX-ARL in %": "4,1",
    "ELF": "4489",
    "ELF in %": "1,1",
    "REP": "2433",
    "REP in %": "0,6",
    "Graue Panther": "3576",
    "Graue Panther in %": "0,9",
    "ALFA": "1469",
    "ALFA in %": "0,4",
    "IBF": "2421",
    "IBF in %": "0,6",
    "Liberale": "1369",
    "Liberale in %": "0,3",
    "P.O.P.": "1238",
    "P.O.P. in %": "0,3",
    "FREIE WÄHLER": "2420",
    "FREIE WÄHLER in %": "0,6",
    "AfD": "42937",
    "AfD in %": "10,8",
    "NPD": "748",
    "NPD in %": "0,2",
    "DIE PARTEI": "6524",
    "DIE PARTEI in %": "1,6",
    "dFfm": "2124",
    "dFfm in %": "0,5"
  },
  {
    "Stadtteilnummer": "21",
    "Stadtteil": "Hausen",
    "Wahlberechtigte insgesamt": "4460",
    "Wähler/innen": "1916",
    "Wähler/innen in %": "43",
    "darunter Wähler mit Wahlschein": "587",
    "darunter Wähler mit Wahlschein in %": "30,6",
    "gültige Stimmen": "166919",
    "CDU": "37041",
    "CDU in %": "22,2",
    "SPD": "47032",
    "SPD in %": "28,2",
    "GRÜNE": "20023",
    "GRÜNE in %": "12",
    "DIE LINKE": "12728",
    "DIE LINKE in %": "7,6",
    "FDP": "13816",
    "FDP in %": "8,3",
    "BFF": "4444",
    "BFF in %": "2,7",
    "PIRATEN": "1273",
    "PIRATEN in %": "0,8",
    "ÖkoLinX-ARL": "2912",
    "ÖkoLinX-ARL in %": "1,7",
    "ELF": "1605",
    "ELF in %": "1",
    "REP": "992",
    "REP in %": "0,6",
    "Graue Panther": "1142",
    "Graue Panther in %": "0,7",
    "ALFA": "729",
    "ALFA in %": "0,4",
    "IBF": "4480",
    "IBF in %": "2,7",
    "Liberale": "435",
    "Liberale in %": "0,3",
    "P.O.P.": "234",
    "P.O.P. in %": "0,1",
    "FREIE WÄHLER": "515",
    "FREIE WÄHLER in %": "0,3",
    "AfD": "14170",
    "AfD in %": "8,5",
    "NPD": "276",
    "NPD in %": "0,2",
    "DIE PARTEI": "2397",
    "DIE PARTEI in %": "1,4",
    "dFfm": "675",
    "dFfm in %": "0,4"
  },
  {
    "Stadtteilnummer": "22",
    "Stadtteil": "Praunheim",
    "Wahlberechtigte insgesamt": "11155",
    "Wähler/innen": "4673",
    "Wähler/innen in %": "41,9",
    "darunter Wähler mit Wahlschein": "1225",
    "darunter Wähler mit Wahlschein in %": "26,2",
    "gültige Stimmen": "397679",
    "CDU": "88156",
    "CDU in %": "22,2",
    "SPD": "110066",
    "SPD in %": "27,7",
    "GRÜNE": "47578",
    "GRÜNE in %": "12",
    "DIE LINKE": "31319",
    "DIE LINKE in %": "7,9",
    "FDP": "28300",
    "FDP in %": "7,1",
    "BFF": "11330",
    "BFF in %": "2,8",
    "PIRATEN": "3784",
    "PIRATEN in %": "1",
    "ÖkoLinX-ARL": "4765",
    "ÖkoLinX-ARL in %": "1,2",
    "ELF": "4614",
    "ELF in %": "1,2",
    "REP": "3557",
    "REP in %": "0,9",
    "Graue Panther": "4123",
    "Graue Panther in %": "1",
    "ALFA": "2334",
    "ALFA in %": "0,6",
    "IBF": "1573",
    "IBF in %": "0,4",
    "Liberale": "460",
    "Liberale in %": "0,1",
    "P.O.P.": "1636",
    "P.O.P. in %": "0,4",
    "FREIE WÄHLER": "1596",
    "FREIE WÄHLER in %": "0,4",
    "AfD": "43101",
    "AfD in %": "10,8",
    "NPD": "1961",
    "NPD in %": "0,5",
    "DIE PARTEI": "4531",
    "DIE PARTEI in %": "1,1",
    "dFfm": "2895",
    "dFfm in %": "0,7"
  },
  {
    "Stadtteilnummer": "24",
    "Stadtteil": "Heddernheim",
    "Wahlberechtigte insgesamt": "11998",
    "Wähler/innen": "4820",
    "Wähler/innen in %": "40,2",
    "darunter Wähler mit Wahlschein": "1141",
    "darunter Wähler mit Wahlschein in %": "23,7",
    "gültige Stimmen": "413383",
    "CDU": "91626",
    "CDU in %": "22,2",
    "SPD": "104126",
    "SPD in %": "25,2",
    "GRÜNE": "56062",
    "GRÜNE in %": "13,6",
    "DIE LINKE": "39267",
    "DIE LINKE in %": "9,5",
    "FDP": "23900",
    "FDP in %": "5,8",
    "BFF": "10664",
    "BFF in %": "2,6",
    "PIRATEN": "3803",
    "PIRATEN in %": "0,9",
    "ÖkoLinX-ARL": "5840",
    "ÖkoLinX-ARL in %": "1,4",
    "ELF": "8419",
    "ELF in %": "2",
    "REP": "2490",
    "REP in %": "0,6",
    "Graue Panther": "1949",
    "Graue Panther in %": "0,5",
    "ALFA": "1994",
    "ALFA in %": "0,5",
    "IBF": "937",
    "IBF in %": "0,2",
    "Liberale": "666",
    "Liberale in %": "0,2",
    "P.O.P.": "2295",
    "P.O.P. in %": "0,6",
    "FREIE WÄHLER": "6060",
    "FREIE WÄHLER in %": "1,5",
    "AfD": "44762",
    "AfD in %": "10,8",
    "NPD": "1590",
    "NPD in %": "0,4",
    "DIE PARTEI": "4913",
    "DIE PARTEI in %": "1,2",
    "dFfm": "2020",
    "dFfm in %": "0,5"
  },
  {
    "Stadtteilnummer": "25",
    "Stadtteil": "Niederursel",
    "Wahlberechtigte insgesamt": "10458",
    "Wähler/innen": "3955",
    "Wähler/innen in %": "37,8",
    "darunter Wähler mit Wahlschein": "886",
    "darunter Wähler mit Wahlschein in %": "22,4",
    "gültige Stimmen": "339385",
    "CDU": "83061",
    "CDU in %": "24,5",
    "SPD": "91633",
    "SPD in %": "27",
    "GRÜNE": "46376",
    "GRÜNE in %": "13,7",
    "DIE LINKE": "22482",
    "DIE LINKE in %": "6,6",
    "FDP": "22708",
    "FDP in %": "6,7",
    "BFF": "7939",
    "BFF in %": "2,3",
    "PIRATEN": "2935",
    "PIRATEN in %": "0,9",
    "ÖkoLinX-ARL": "4843",
    "ÖkoLinX-ARL in %": "1,4",
    "ELF": "4378",
    "ELF in %": "1,3",
    "REP": "1332",
    "REP in %": "0,4",
    "Graue Panther": "2608",
    "Graue Panther in %": "0,8",
    "ALFA": "1400",
    "ALFA in %": "0,4",
    "IBF": "1513",
    "IBF in %": "0,4",
    "Liberale": "985",
    "Liberale in %": "0,3",
    "P.O.P.": "1678",
    "P.O.P. in %": "0,5",
    "FREIE WÄHLER": "1920",
    "FREIE WÄHLER in %": "0,6",
    "AfD": "35198",
    "AfD in %": "10,4",
    "NPD": "1625",
    "NPD in %": "0,5",
    "DIE PARTEI": "3141",
    "DIE PARTEI in %": "0,9",
    "dFfm": "1630",
    "dFfm in %": "0,5"
  },
  {
    "Stadtteilnummer": "26",
    "Stadtteil": "Ginnheim",
    "Wahlberechtigte insgesamt": "11367",
    "Wähler/innen": "4600",
    "Wähler/innen in %": "40,5",
    "darunter Wähler mit Wahlschein": "1183",
    "darunter Wähler mit Wahlschein in %": "25,7",
    "gültige Stimmen": "397356",
    "CDU": "84642",
    "CDU in %": "21,3",
    "SPD": "105997",
    "SPD in %": "26,7",
    "GRÜNE": "58077",
    "GRÜNE in %": "14,6",
    "DIE LINKE": "35842",
    "DIE LINKE in %": "9",
    "FDP": "28101",
    "FDP in %": "7,1",
    "BFF": "15215",
    "BFF in %": "3,8",
    "PIRATEN": "2498",
    "PIRATEN in %": "0,6",
    "ÖkoLinX-ARL": "7949",
    "ÖkoLinX-ARL in %": "2",
    "ELF": "5022",
    "ELF in %": "1,3",
    "REP": "1900",
    "REP in %": "0,5",
    "Graue Panther": "2144",
    "Graue Panther in %": "0,5",
    "ALFA": "2437",
    "ALFA in %": "0,6",
    "IBF": "1244",
    "IBF in %": "0,3",
    "Liberale": "1177",
    "Liberale in %": "0,3",
    "P.O.P.": "1298",
    "P.O.P. in %": "0,3",
    "FREIE WÄHLER": "1664",
    "FREIE WÄHLER in %": "0,4",
    "AfD": "32651",
    "AfD in %": "8,2",
    "NPD": "709",
    "NPD in %": "0,2",
    "DIE PARTEI": "5703",
    "DIE PARTEI in %": "1,4",
    "dFfm": "3086",
    "dFfm in %": "0,8"
  },
  {
    "Stadtteilnummer": "27",
    "Stadtteil": "Dornbusch",
    "Wahlberechtigte insgesamt": "13558",
    "Wähler/innen": "6356",
    "Wähler/innen in %": "46,9",
    "darunter Wähler mit Wahlschein": "1653",
    "darunter Wähler mit Wahlschein in %": "26",
    "gültige Stimmen": "558256",
    "CDU": "139404",
    "CDU in %": "25",
    "SPD": "127277",
    "SPD in %": "22,8",
    "GRÜNE": "86536",
    "GRÜNE in %": "15,5",
    "DIE LINKE": "40635",
    "DIE LINKE in %": "7,3",
    "FDP": "59951",
    "FDP in %": "10,7",
    "BFF": "16729",
    "BFF in %": "3",
    "PIRATEN": "4412",
    "PIRATEN in %": "0,8",
    "ÖkoLinX-ARL": "11193",
    "ÖkoLinX-ARL in %": "2",
    "ELF": "3738",
    "ELF in %": "0,7",
    "REP": "880",
    "REP in %": "0,2",
    "Graue Panther": "3389",
    "Graue Panther in %": "0,6",
    "ALFA": "2121",
    "ALFA in %": "0,4",
    "IBF": "1301",
    "IBF in %": "0,2",
    "Liberale": "1752",
    "Liberale in %": "0,3",
    "P.O.P.": "2260",
    "P.O.P. in %": "0,4",
    "FREIE WÄHLER": "3274",
    "FREIE WÄHLER in %": "0,6",
    "AfD": "42501",
    "AfD in %": "7,6",
    "NPD": "1138",
    "NPD in %": "0,2",
    "DIE PARTEI": "6382",
    "DIE PARTEI in %": "1,1",
    "dFfm": "3383",
    "dFfm in %": "0,6"
  },
  {
    "Stadtteilnummer": "28",
    "Stadtteil": "Eschersheim",
    "Wahlberechtigte insgesamt": "11195",
    "Wähler/innen": "5105",
    "Wähler/innen in %": "45,6",
    "darunter Wähler mit Wahlschein": "1303",
    "darunter Wähler mit Wahlschein in %": "25,5",
    "gültige Stimmen": "445483",
    "CDU": "117916",
    "CDU in %": "26,5",
    "SPD": "105875",
    "SPD in %": "23,8",
    "GRÜNE": "69063",
    "GRÜNE in %": "15,5",
    "DIE LINKE": "33480",
    "DIE LINKE in %": "7,5",
    "FDP": "42084",
    "FDP in %": "9,4",
    "BFF": "11673",
    "BFF in %": "2,6",
    "PIRATEN": "3133",
    "PIRATEN in %": "0,7",
    "ÖkoLinX-ARL": "6891",
    "ÖkoLinX-ARL in %": "1,5",
    "ELF": "3165",
    "ELF in %": "0,7",
    "REP": "1066",
    "REP in %": "0,2",
    "Graue Panther": "1900",
    "Graue Panther in %": "0,4",
    "ALFA": "2277",
    "ALFA in %": "0,5",
    "IBF": "1462",
    "IBF in %": "0,3",
    "Liberale": "877",
    "Liberale in %": "0,2",
    "P.O.P.": "1827",
    "P.O.P. in %": "0,4",
    "FREIE WÄHLER": "1718",
    "FREIE WÄHLER in %": "0,4",
    "AfD": "32477",
    "AfD in %": "7,3",
    "NPD": "602",
    "NPD in %": "0,1",
    "DIE PARTEI": "5135",
    "DIE PARTEI in %": "1,2",
    "dFfm": "2862",
    "dFfm in %": "0,6"
  },
  {
    "Stadtteilnummer": "29",
    "Stadtteil": "Eckenheim",
    "Wahlberechtigte insgesamt": "9608",
    "Wähler/innen": "3524",
    "Wähler/innen in %": "36,7",
    "darunter Wähler mit Wahlschein": "821",
    "darunter Wähler mit Wahlschein in %": "23,3",
    "gültige Stimmen": "303786",
    "CDU": "65552",
    "CDU in %": "21,6",
    "SPD": "83184",
    "SPD in %": "27,4",
    "GRÜNE": "36400",
    "GRÜNE in %": "12",
    "DIE LINKE": "29636",
    "DIE LINKE in %": "9,8",
    "FDP": "18310",
    "FDP in %": "6",
    "BFF": "10660",
    "BFF in %": "3,5",
    "PIRATEN": "3664",
    "PIRATEN in %": "1,2",
    "ÖkoLinX-ARL": "6889",
    "ÖkoLinX-ARL in %": "2,3",
    "ELF": "3882",
    "ELF in %": "1,3",
    "REP": "844",
    "REP in %": "0,3",
    "Graue Panther": "2295",
    "Graue Panther in %": "0,8",
    "ALFA": "1687",
    "ALFA in %": "0,6",
    "IBF": "1045",
    "IBF in %": "0,3",
    "Liberale": "966",
    "Liberale in %": "0,3",
    "P.O.P.": "1581",
    "P.O.P. in %": "0,5",
    "FREIE WÄHLER": "1332",
    "FREIE WÄHLER in %": "0,4",
    "AfD": "29211",
    "AfD in %": "9,6",
    "NPD": "1232",
    "NPD in %": "0,4",
    "DIE PARTEI": "3005",
    "DIE PARTEI in %": "1",
    "dFfm": "2411",
    "dFfm in %": "0,8"
  },
  {
    "Stadtteilnummer": "30",
    "Stadtteil": "Preungesheim",
    "Wahlberechtigte insgesamt": "9975",
    "Wähler/innen": "4033",
    "Wähler/innen in %": "40,4",
    "darunter Wähler mit Wahlschein": "928",
    "darunter Wähler mit Wahlschein in %": "23",
    "gültige Stimmen": "351663",
    "CDU": "81047",
    "CDU in %": "23",
    "SPD": "91469",
    "SPD in %": "26",
    "GRÜNE": "50847",
    "GRÜNE in %": "14,5",
    "DIE LINKE": "29870",
    "DIE LINKE in %": "8,5",
    "FDP": "24871",
    "FDP in %": "7,1",
    "BFF": "9208",
    "BFF in %": "2,6",
    "PIRATEN": "2185",
    "PIRATEN in %": "0,6",
    "ÖkoLinX-ARL": "6581",
    "ÖkoLinX-ARL in %": "1,9",
    "ELF": "6300",
    "ELF in %": "1,8",
    "REP": "726",
    "REP in %": "0,2",
    "Graue Panther": "1999",
    "Graue Panther in %": "0,6",
    "ALFA": "2265",
    "ALFA in %": "0,6",
    "IBF": "1375",
    "IBF in %": "0,4",
    "Liberale": "222",
    "Liberale in %": "0,1",
    "P.O.P.": "2259",
    "P.O.P. in %": "0,6",
    "FREIE WÄHLER": "2210",
    "FREIE WÄHLER in %": "0,6",
    "AfD": "31778",
    "AfD in %": "9",
    "NPD": "738",
    "NPD in %": "0,2",
    "DIE PARTEI": "3694",
    "DIE PARTEI in %": "1,1",
    "dFfm": "2019",
    "dFfm in %": "0,6"
  },
  {
    "Stadtteilnummer": "31",
    "Stadtteil": "Bonames",
    "Wahlberechtigte insgesamt": "4550",
    "Wähler/innen": "1610",
    "Wähler/innen in %": "35,4",
    "darunter Wähler mit Wahlschein": "381",
    "darunter Wähler mit Wahlschein in %": "23,7",
    "gültige Stimmen": "135916",
    "CDU": "30537",
    "CDU in %": "22,5",
    "SPD": "34782",
    "SPD in %": "25,6",
    "GRÜNE": "13755",
    "GRÜNE in %": "10,1",
    "DIE LINKE": "10223",
    "DIE LINKE in %": "7,5",
    "FDP": "6684",
    "FDP in %": "4,9",
    "BFF": "9611",
    "BFF in %": "7,1",
    "PIRATEN": "998",
    "PIRATEN in %": "0,7",
    "ÖkoLinX-ARL": "2176",
    "ÖkoLinX-ARL in %": "1,6",
    "ELF": "1649",
    "ELF in %": "1,2",
    "REP": "628",
    "REP in %": "0,5",
    "Graue Panther": "618",
    "Graue Panther in %": "0,5",
    "ALFA": "605",
    "ALFA in %": "0,4",
    "IBF": "950",
    "IBF in %": "0,7",
    "Liberale": "361",
    "Liberale in %": "0,3",
    "P.O.P.": "317",
    "P.O.P. in %": "0,2",
    "FREIE WÄHLER": "1908",
    "FREIE WÄHLER in %": "1,4",
    "AfD": "16834",
    "AfD in %": "12,4",
    "NPD": "527",
    "NPD in %": "0,4",
    "DIE PARTEI": "1161",
    "DIE PARTEI in %": "0,9",
    "dFfm": "1592",
    "dFfm in %": "1,2"
  },
  {
    "Stadtteilnummer": "32",
    "Stadtteil": "Berkersheim",
    "Wahlberechtigte insgesamt": "2598",
    "Wähler/innen": "1264",
    "Wähler/innen in %": "48,7",
    "darunter Wähler mit Wahlschein": "347",
    "darunter Wähler mit Wahlschein in %": "27,5",
    "gültige Stimmen": "109268",
    "CDU": "31003",
    "CDU in %": "28,4",
    "SPD": "24063",
    "SPD in %": "22",
    "GRÜNE": "13096",
    "GRÜNE in %": "12",
    "DIE LINKE": "7514",
    "DIE LINKE in %": "6,9",
    "FDP": "9879",
    "FDP in %": "9",
    "BFF": "3090",
    "BFF in %": "2,8",
    "PIRATEN": "896",
    "PIRATEN in %": "0,8",
    "ÖkoLinX-ARL": "1653",
    "ÖkoLinX-ARL in %": "1,5",
    "ELF": "2101",
    "ELF in %": "1,9",
    "REP": "390",
    "REP in %": "0,4",
    "Graue Panther": "239",
    "Graue Panther in %": "0,2",
    "ALFA": "551",
    "ALFA in %": "0,5",
    "IBF": "459",
    "IBF in %": "0,4",
    "Liberale": "322",
    "Liberale in %": "0,3",
    "P.O.P.": "618",
    "P.O.P. in %": "0,6",
    "FREIE WÄHLER": "113",
    "FREIE WÄHLER in %": "0,1",
    "AfD": "11569",
    "AfD in %": "10,6",
    "NPD": "181",
    "NPD in %": "0,2",
    "DIE PARTEI": "1019",
    "DIE PARTEI in %": "0,9",
    "dFfm": "512",
    "dFfm in %": "0,5"
  },
  {
    "Stadtteilnummer": "33",
    "Stadtteil": "Riederwald",
    "Wahlberechtigte insgesamt": "3085",
    "Wähler/innen": "1108",
    "Wähler/innen in %": "35,9",
    "darunter Wähler mit Wahlschein": "263",
    "darunter Wähler mit Wahlschein in %": "23,7",
    "gültige Stimmen": "92905",
    "CDU": "11713",
    "CDU in %": "12,6",
    "SPD": "28070",
    "SPD in %": "30,2",
    "GRÜNE": "6055",
    "GRÜNE in %": "6,5",
    "DIE LINKE": "12460",
    "DIE LINKE in %": "13,4",
    "FDP": "3644",
    "FDP in %": "3,9",
    "BFF": "2440",
    "BFF in %": "2,6",
    "PIRATEN": "855",
    "PIRATEN in %": "0,9",
    "ÖkoLinX-ARL": "1590",
    "ÖkoLinX-ARL in %": "1,7",
    "ELF": "2745",
    "ELF in %": "3",
    "REP": "890",
    "REP in %": "1",
    "Graue Panther": "1134",
    "Graue Panther in %": "1,2",
    "ALFA": "106",
    "ALFA in %": "0,1",
    "IBF": "551",
    "IBF in %": "0,6",
    "Liberale": "114",
    "Liberale in %": "0,1",
    "P.O.P.": "5160",
    "P.O.P. in %": "5,6",
    "FREIE WÄHLER": "443",
    "FREIE WÄHLER in %": "0,5",
    "AfD": "12666",
    "AfD in %": "13,6",
    "NPD": "148",
    "NPD in %": "0,2",
    "DIE PARTEI": "1485",
    "DIE PARTEI in %": "1,6",
    "dFfm": "636",
    "dFfm in %": "0,7"
  },
  {
    "Stadtteilnummer": "34",
    "Stadtteil": "Seckbach",
    "Wahlberechtigte insgesamt": "7506",
    "Wähler/innen": "3013",
    "Wähler/innen in %": "40,1",
    "darunter Wähler mit Wahlschein": "794",
    "darunter Wähler mit Wahlschein in %": "26,4",
    "gültige Stimmen": "260806",
    "CDU": "64562",
    "CDU in %": "24,8",
    "SPD": "67815",
    "SPD in %": "26",
    "GRÜNE": "37593",
    "GRÜNE in %": "14,4",
    "DIE LINKE": "20273",
    "DIE LINKE in %": "7,8",
    "FDP": "17881",
    "FDP in %": "6,9",
    "BFF": "7220",
    "BFF in %": "2,8",
    "PIRATEN": "1104",
    "PIRATEN in %": "0,4",
    "ÖkoLinX-ARL": "4793",
    "ÖkoLinX-ARL in %": "1,8",
    "ELF": "3022",
    "ELF in %": "1,2",
    "REP": "774",
    "REP in %": "0,3",
    "Graue Panther": "1332",
    "Graue Panther in %": "0,5",
    "ALFA": "919",
    "ALFA in %": "0,4",
    "IBF": "755",
    "IBF in %": "0,3",
    "Liberale": "230",
    "Liberale in %": "0,1",
    "P.O.P.": "1755",
    "P.O.P. in %": "0,7",
    "FREIE WÄHLER": "1120",
    "FREIE WÄHLER in %": "0,4",
    "AfD": "22771",
    "AfD in %": "8,7",
    "NPD": "771",
    "NPD in %": "0,3",
    "DIE PARTEI": "3022",
    "DIE PARTEI in %": "1,2",
    "dFfm": "3094",
    "dFfm in %": "1,2"
  },
  {
    "Stadtteilnummer": "35",
    "Stadtteil": "Fechenheim",
    "Wahlberechtigte insgesamt": "10257",
    "Wähler/innen": "2809",
    "Wähler/innen in %": "27,4",
    "darunter Wähler mit Wahlschein": "714",
    "darunter Wähler mit Wahlschein in %": "25,4",
    "gültige Stimmen": "234606",
    "CDU": "51446",
    "CDU in %": "21,9",
    "SPD": "67452",
    "SPD in %": "28,8",
    "GRÜNE": "23899",
    "GRÜNE in %": "10,2",
    "DIE LINKE": "19205",
    "DIE LINKE in %": "8,2",
    "FDP": "9518",
    "FDP in %": "4,1",
    "BFF": "7443",
    "BFF in %": "3,2",
    "PIRATEN": "1418",
    "PIRATEN in %": "0,6",
    "ÖkoLinX-ARL": "2522",
    "ÖkoLinX-ARL in %": "1,1",
    "ELF": "5133",
    "ELF in %": "2,2",
    "REP": "1479",
    "REP in %": "0,6",
    "Graue Panther": "1352",
    "Graue Panther in %": "0,6",
    "ALFA": "1225",
    "ALFA in %": "0,5",
    "IBF": "1088",
    "IBF in %": "0,5",
    "Liberale": "280",
    "Liberale in %": "0,1",
    "P.O.P.": "2389",
    "P.O.P. in %": "1",
    "FREIE WÄHLER": "1218",
    "FREIE WÄHLER in %": "0,5",
    "AfD": "31974",
    "AfD in %": "13,6",
    "NPD": "1010",
    "NPD in %": "0,4",
    "DIE PARTEI": "2271",
    "DIE PARTEI in %": "1",
    "dFfm": "2284",
    "dFfm in %": "1"
  },
  {
    "Stadtteilnummer": "36",
    "Stadtteil": "Höchst",
    "Wahlberechtigte insgesamt": "9842",
    "Wähler/innen": "2645",
    "Wähler/innen in %": "26,9",
    "darunter Wähler mit Wahlschein": "568",
    "darunter Wähler mit Wahlschein in %": "21,5",
    "gültige Stimmen": "224771",
    "CDU": "43130",
    "CDU in %": "19,2",
    "SPD": "60066",
    "SPD in %": "26,7",
    "GRÜNE": "28828",
    "GRÜNE in %": "12,8",
    "DIE LINKE": "25957",
    "DIE LINKE in %": "11,5",
    "FDP": "10381",
    "FDP in %": "4,6",
    "BFF": "4832",
    "BFF in %": "2,1",
    "PIRATEN": "3782",
    "PIRATEN in %": "1,7",
    "ÖkoLinX-ARL": "4145",
    "ÖkoLinX-ARL in %": "1,8",
    "ELF": "6747",
    "ELF in %": "3",
    "REP": "1096",
    "REP in %": "0,5",
    "Graue Panther": "996",
    "Graue Panther in %": "0,4",
    "ALFA": "1188",
    "ALFA in %": "0,5",
    "IBF": "879",
    "IBF in %": "0,4",
    "Liberale": "363",
    "Liberale in %": "0,2",
    "P.O.P.": "505",
    "P.O.P. in %": "0,2",
    "FREIE WÄHLER": "2039",
    "FREIE WÄHLER in %": "0,9",
    "AfD": "22784",
    "AfD in %": "10,1",
    "NPD": "868",
    "NPD in %": "0,4",
    "DIE PARTEI": "5218",
    "DIE PARTEI in %": "2,3",
    "dFfm": "967",
    "dFfm in %": "0,4"
  },
  {
    "Stadtteilnummer": "37",
    "Stadtteil": "Nied",
    "Wahlberechtigte insgesamt": "12646",
    "Wähler/innen": "3919",
    "Wähler/innen in %": "31",
    "darunter Wähler mit Wahlschein": "856",
    "darunter Wähler mit Wahlschein in %": "21,8",
    "gültige Stimmen": "329545",
    "CDU": "73777",
    "CDU in %": "22,4",
    "SPD": "88783",
    "SPD in %": "26,9",
    "GRÜNE": "29702",
    "GRÜNE in %": "9",
    "DIE LINKE": "23148",
    "DIE LINKE in %": "7",
    "FDP": "20108",
    "FDP in %": "6,1",
    "BFF": "9293",
    "BFF in %": "2,8",
    "PIRATEN": "2404",
    "PIRATEN in %": "0,7",
    "ÖkoLinX-ARL": "3028",
    "ÖkoLinX-ARL in %": "0,9",
    "ELF": "7126",
    "ELF in %": "2,2",
    "REP": "2507",
    "REP in %": "0,8",
    "Graue Panther": "2553",
    "Graue Panther in %": "0,8",
    "ALFA": "1500",
    "ALFA in %": "0,5",
    "IBF": "2132",
    "IBF in %": "0,6",
    "Liberale": "599",
    "Liberale in %": "0,2",
    "P.O.P.": "625",
    "P.O.P. in %": "0,2",
    "FREIE WÄHLER": "3604",
    "FREIE WÄHLER in %": "1,1",
    "AfD": "50376",
    "AfD in %": "15,3",
    "NPD": "2460",
    "NPD in %": "0,7",
    "DIE PARTEI": "4680",
    "DIE PARTEI in %": "1,4",
    "dFfm": "1140",
    "dFfm in %": "0,3"
  },
  {
    "Stadtteilnummer": "38",
    "Stadtteil": "Sindlingen",
    "Wahlberechtigte insgesamt": "5983",
    "Wähler/innen": "2031",
    "Wähler/innen in %": "33,9",
    "darunter Wähler mit Wahlschein": "403",
    "darunter Wähler mit Wahlschein in %": "19,8",
    "gültige Stimmen": "165071",
    "CDU": "51383",
    "CDU in %": "31,1",
    "SPD": "49384",
    "SPD in %": "29,9",
    "GRÜNE": "11597",
    "GRÜNE in %": "7",
    "DIE LINKE": "8372",
    "DIE LINKE in %": "5,1",
    "FDP": "5219",
    "FDP in %": "3,2",
    "BFF": "5162",
    "BFF in %": "3,1",
    "PIRATEN": "821",
    "PIRATEN in %": "0,5",
    "ÖkoLinX-ARL": "762",
    "ÖkoLinX-ARL in %": "0,5",
    "ELF": "1668",
    "ELF in %": "1",
    "REP": "1120",
    "REP in %": "0,7",
    "Graue Panther": "797",
    "Graue Panther in %": "0,5",
    "ALFA": "501",
    "ALFA in %": "0,3",
    "IBF": "522",
    "IBF in %": "0,3",
    "Liberale": "27",
    "Liberale in %": "0",
    "P.O.P.": "576",
    "P.O.P. in %": "0,3",
    "FREIE WÄHLER": "1284",
    "FREIE WÄHLER in %": "0,8",
    "AfD": "23677",
    "AfD in %": "14,3",
    "NPD": "392",
    "NPD in %": "0,2",
    "DIE PARTEI": "1581",
    "DIE PARTEI in %": "1",
    "dFfm": "226",
    "dFfm in %": "0,1"
  },
  {
    "Stadtteilnummer": "39",
    "Stadtteil": "Zeilsheim",
    "Wahlberechtigte insgesamt": "8133",
    "Wähler/innen": "2757",
    "Wähler/innen in %": "33,9",
    "darunter Wähler mit Wahlschein": "662",
    "darunter Wähler mit Wahlschein in %": "24",
    "gültige Stimmen": "229529",
    "CDU": "81211",
    "CDU in %": "35,4",
    "SPD": "54475",
    "SPD in %": "23,7",
    "GRÜNE": "16516",
    "GRÜNE in %": "7,2",
    "DIE LINKE": "12663",
    "DIE LINKE in %": "5,5",
    "FDP": "7635",
    "FDP in %": "3,3",
    "BFF": "6840",
    "BFF in %": "3",
    "PIRATEN": "2162",
    "PIRATEN in %": "0,9",
    "ÖkoLinX-ARL": "822",
    "ÖkoLinX-ARL in %": "0,4",
    "ELF": "2147",
    "ELF in %": "0,9",
    "REP": "1467",
    "REP in %": "0,6",
    "Graue Panther": "2079",
    "Graue Panther in %": "0,9",
    "ALFA": "840",
    "ALFA in %": "0,4",
    "IBF": "1017",
    "IBF in %": "0,4",
    "Liberale": "212",
    "Liberale in %": "0,1",
    "P.O.P.": "239",
    "P.O.P. in %": "0,1",
    "FREIE WÄHLER": "2160",
    "FREIE WÄHLER in %": "0,9",
    "AfD": "32366",
    "AfD in %": "14,1",
    "NPD": "1380",
    "NPD in %": "0,6",
    "DIE PARTEI": "1992",
    "DIE PARTEI in %": "0,9",
    "dFfm": "1306",
    "dFfm in %": "0,6"
  },
  {
    "Stadtteilnummer": "40",
    "Stadtteil": "Unterliederbach",
    "Wahlberechtigte insgesamt": "10383",
    "Wähler/innen": "3600",
    "Wähler/innen in %": "34,7",
    "darunter Wähler mit Wahlschein": "749",
    "darunter Wähler mit Wahlschein in %": "20,8",
    "gültige Stimmen": "306242",
    "CDU": "87348",
    "CDU in %": "28,5",
    "SPD": "73586",
    "SPD in %": "24",
    "GRÜNE": "34220",
    "GRÜNE in %": "11,2",
    "DIE LINKE": "17270",
    "DIE LINKE in %": "5,6",
    "FDP": "17124",
    "FDP in %": "5,6",
    "BFF": "7160",
    "BFF in %": "2,3",
    "PIRATEN": "2467",
    "PIRATEN in %": "0,8",
    "ÖkoLinX-ARL": "2353",
    "ÖkoLinX-ARL in %": "0,8",
    "ELF": "8162",
    "ELF in %": "2,7",
    "REP": "2827",
    "REP in %": "0,9",
    "Graue Panther": "2009",
    "Graue Panther in %": "0,7",
    "ALFA": "1846",
    "ALFA in %": "0,6",
    "IBF": "1854",
    "IBF in %": "0,6",
    "Liberale": "509",
    "Liberale in %": "0,2",
    "P.O.P.": "509",
    "P.O.P. in %": "0,2",
    "FREIE WÄHLER": "3030",
    "FREIE WÄHLER in %": "1",
    "AfD": "36685",
    "AfD in %": "12",
    "NPD": "1406",
    "NPD in %": "0,5",
    "DIE PARTEI": "4505",
    "DIE PARTEI in %": "1,5",
    "dFfm": "1372",
    "dFfm in %": "0,4"
  },
  {
    "Stadtteilnummer": "41",
    "Stadtteil": "Sossenheim",
    "Wahlberechtigte insgesamt": "10297",
    "Wähler/innen": "3110",
    "Wähler/innen in %": "30,2",
    "darunter Wähler mit Wahlschein": "647",
    "darunter Wähler mit Wahlschein in %": "20,8",
    "gültige Stimmen": "261779",
    "CDU": "85177",
    "CDU in %": "32,5",
    "SPD": "60810",
    "SPD in %": "23,2",
    "GRÜNE": "21255",
    "GRÜNE in %": "8,1",
    "DIE LINKE": "15218",
    "DIE LINKE in %": "5,8",
    "FDP": "12340",
    "FDP in %": "4,7",
    "BFF": "6937",
    "BFF in %": "2,6",
    "PIRATEN": "1266",
    "PIRATEN in %": "0,5",
    "ÖkoLinX-ARL": "2165",
    "ÖkoLinX-ARL in %": "0,8",
    "ELF": "4451",
    "ELF in %": "1,7",
    "REP": "2971",
    "REP in %": "1,1",
    "Graue Panther": "1949",
    "Graue Panther in %": "0,7",
    "ALFA": "1133",
    "ALFA in %": "0,4",
    "IBF": "1150",
    "IBF in %": "0,4",
    "Liberale": "333",
    "Liberale in %": "0,1",
    "P.O.P.": "334",
    "P.O.P. in %": "0,1",
    "FREIE WÄHLER": "1742",
    "FREIE WÄHLER in %": "0,7",
    "AfD": "36042",
    "AfD in %": "13,8",
    "NPD": "1652",
    "NPD in %": "0,6",
    "DIE PARTEI": "3683",
    "DIE PARTEI in %": "1,4",
    "dFfm": "1171",
    "dFfm in %": "0,4"
  },
  {
    "Stadtteilnummer": "42",
    "Stadtteil": "Nieder-Erlenbach",
    "Wahlberechtigte insgesamt": "3564",
    "Wähler/innen": "2024",
    "Wähler/innen in %": "56,8",
    "darunter Wähler mit Wahlschein": "488",
    "darunter Wähler mit Wahlschein in %": "24,1",
    "gültige Stimmen": "176176",
    "CDU": "78614",
    "CDU in %": "44,6",
    "SPD": "26776",
    "SPD in %": "15,2",
    "GRÜNE": "26207",
    "GRÜNE in %": "14,9",
    "DIE LINKE": "5028",
    "DIE LINKE in %": "2,9",
    "FDP": "12077",
    "FDP in %": "6,9",
    "BFF": "6104",
    "BFF in %": "3,5",
    "PIRATEN": "790",
    "PIRATEN in %": "0,4",
    "ÖkoLinX-ARL": "1023",
    "ÖkoLinX-ARL in %": "0,6",
    "ELF": "555",
    "ELF in %": "0,3",
    "REP": "167",
    "REP in %": "0,1",
    "Graue Panther": "505",
    "Graue Panther in %": "0,3",
    "ALFA": "1003",
    "ALFA in %": "0,6",
    "IBF": "29",
    "IBF in %": "0",
    "Liberale": "307",
    "Liberale in %": "0,2",
    "P.O.P.": "370",
    "P.O.P. in %": "0,2",
    "FREIE WÄHLER": "1119",
    "FREIE WÄHLER in %": "0,6",
    "AfD": "13005",
    "AfD in %": "7,4",
    "NPD": "210",
    "NPD in %": "0,1",
    "DIE PARTEI": "1620",
    "DIE PARTEI in %": "0,9",
    "dFfm": "667",
    "dFfm in %": "0,4"
  },
  {
    "Stadtteilnummer": "43",
    "Stadtteil": "Kalbach-Riedberg",
    "Wahlberechtigte insgesamt": "10819",
    "Wähler/innen": "5181",
    "Wähler/innen in %": "47,9",
    "darunter Wähler mit Wahlschein": "1043",
    "darunter Wähler mit Wahlschein in %": "20,1",
    "gültige Stimmen": "455513",
    "CDU": "154466",
    "CDU in %": "33,9",
    "SPD": "89958",
    "SPD in %": "19,7",
    "GRÜNE": "69968",
    "GRÜNE in %": "15,4",
    "DIE LINKE": "16573",
    "DIE LINKE in %": "3,6",
    "FDP": "48722",
    "FDP in %": "10,7",
    "BFF": "9667",
    "BFF in %": "2,1",
    "PIRATEN": "3561",
    "PIRATEN in %": "0,8",
    "ÖkoLinX-ARL": "1307",
    "ÖkoLinX-ARL in %": "0,3",
    "ELF": "3686",
    "ELF in %": "0,8",
    "REP": "823",
    "REP in %": "0,2",
    "Graue Panther": "1766",
    "Graue Panther in %": "0,4",
    "ALFA": "4045",
    "ALFA in %": "0,9",
    "IBF": "1496",
    "IBF in %": "0,3",
    "Liberale": "618",
    "Liberale in %": "0,1",
    "P.O.P.": "1338",
    "P.O.P. in %": "0,3",
    "FREIE WÄHLER": "2085",
    "FREIE WÄHLER in %": "0,5",
    "AfD": "38418",
    "AfD in %": "8,4",
    "NPD": "754",
    "NPD in %": "0,2",
    "DIE PARTEI": "3985",
    "DIE PARTEI in %": "0,9",
    "dFfm": "2277",
    "dFfm in %": "0,5"
  },
  {
    "Stadtteilnummer": "44",
    "Stadtteil": "Harheim",
    "Wahlberechtigte insgesamt": "3584",
    "Wähler/innen": "2060",
    "Wähler/innen in %": "57,5",
    "darunter Wähler mit Wahlschein": "477",
    "darunter Wähler mit Wahlschein in %": "23,2",
    "gültige Stimmen": "177173",
    "CDU": "69497",
    "CDU in %": "39,2",
    "SPD": "28631",
    "SPD in %": "16,2",
    "GRÜNE": "29044",
    "GRÜNE in %": "16,4",
    "DIE LINKE": "6807",
    "DIE LINKE in %": "3,8",
    "FDP": "8987",
    "FDP in %": "5,1",
    "BFF": "5753",
    "BFF in %": "3,2",
    "PIRATEN": "595",
    "PIRATEN in %": "0,3",
    "ÖkoLinX-ARL": "1065",
    "ÖkoLinX-ARL in %": "0,6",
    "ELF": "553",
    "ELF in %": "0,3",
    "REP": "601",
    "REP in %": "0,3",
    "Graue Panther": "428",
    "Graue Panther in %": "0,2",
    "ALFA": "2026",
    "ALFA in %": "1,1",
    "IBF": "209",
    "IBF in %": "0,1",
    "Liberale": "347",
    "Liberale in %": "0,2",
    "P.O.P.": "472",
    "P.O.P. in %": "0,3",
    "FREIE WÄHLER": "639",
    "FREIE WÄHLER in %": "0,4",
    "AfD": "18964",
    "AfD in %": "10,7",
    "NPD": "296",
    "NPD in %": "0,2",
    "DIE PARTEI": "1378",
    "DIE PARTEI in %": "0,8",
    "dFfm": "881",
    "dFfm in %": "0,5"
  },
  {
    "Stadtteilnummer": "45",
    "Stadtteil": "Nieder-Eschbach",
    "Wahlberechtigte insgesamt": "8083",
    "Wähler/innen": "3300",
    "Wähler/innen in %": "40,8",
    "darunter Wähler mit Wahlschein": "849",
    "darunter Wähler mit Wahlschein in %": "25,7",
    "gültige Stimmen": "276469",
    "CDU": "94102",
    "CDU in %": "34",
    "SPD": "49997",
    "SPD in %": "18,1",
    "GRÜNE": "39554",
    "GRÜNE in %": "14,3",
    "DIE LINKE": "13797",
    "DIE LINKE in %": "5",
    "FDP": "15789",
    "FDP in %": "5,7",
    "BFF": "10304",
    "BFF in %": "3,7",
    "PIRATEN": "1776",
    "PIRATEN in %": "0,6",
    "ÖkoLinX-ARL": "1966",
    "ÖkoLinX-ARL in %": "0,7",
    "ELF": "3044",
    "ELF in %": "1,1",
    "REP": "479",
    "REP in %": "0,2",
    "Graue Panther": "924",
    "Graue Panther in %": "0,3",
    "ALFA": "1900",
    "ALFA in %": "0,7",
    "IBF": "1309",
    "IBF in %": "0,5",
    "Liberale": "360",
    "Liberale in %": "0,1",
    "P.O.P.": "526",
    "P.O.P. in %": "0,2",
    "FREIE WÄHLER": "4255",
    "FREIE WÄHLER in %": "1,5",
    "AfD": "31161",
    "AfD in %": "11,3",
    "NPD": "1204",
    "NPD in %": "0,4",
    "DIE PARTEI": "3284",
    "DIE PARTEI in %": "1,2",
    "dFfm": "738",
    "dFfm in %": "0,3"
  },
  {
    "Stadtteilnummer": "46",
    "Stadtteil": "Bergen-Enkheim",
    "Wahlberechtigte insgesamt": "13638",
    "Wähler/innen": "6571",
    "Wähler/innen in %": "48,2",
    "darunter Wähler mit Wahlschein": "1708",
    "darunter Wähler mit Wahlschein in %": "26",
    "gültige Stimmen": "568365",
    "CDU": "163634",
    "CDU in %": "28,8",
    "SPD": "133465",
    "SPD in %": "23,5",
    "GRÜNE": "70209",
    "GRÜNE in %": "12,4",
    "DIE LINKE": "29201",
    "DIE LINKE in %": "5,1",
    "FDP": "37372",
    "FDP in %": "6,6",
    "BFF": "28041",
    "BFF in %": "4,9",
    "PIRATEN": "3410",
    "PIRATEN in %": "0,6",
    "ÖkoLinX-ARL": "7156",
    "ÖkoLinX-ARL in %": "1,3",
    "ELF": "4037",
    "ELF in %": "0,7",
    "REP": "1074",
    "REP in %": "0,2",
    "Graue Panther": "2492",
    "Graue Panther in %": "0,4",
    "ALFA": "3878",
    "ALFA in %": "0,7",
    "IBF": "1933",
    "IBF in %": "0,3",
    "Liberale": "758",
    "Liberale in %": "0,1",
    "P.O.P.": "4172",
    "P.O.P. in %": "0,7",
    "FREIE WÄHLER": "3696",
    "FREIE WÄHLER in %": "0,7",
    "AfD": "63306",
    "AfD in %": "11,1",
    "NPD": "1640",
    "NPD in %": "0,3",
    "DIE PARTEI": "5333",
    "DIE PARTEI in %": "0,9",
    "dFfm": "3558",
    "dFfm in %": "0,6"
  },
  {
    "Stadtteilnummer": "47",
    "Stadtteil": "Frankfurter Berg",
    "Wahlberechtigte insgesamt": "5362",
    "Wähler/innen": "2211",
    "Wähler/innen in %": "41,2",
    "darunter Wähler mit Wahlschein": "493",
    "darunter Wähler mit Wahlschein in %": "22,3",
    "gültige Stimmen": "189602",
    "CDU": "47009",
    "CDU in %": "24,8",
    "SPD": "48304",
    "SPD in %": "25,5",
    "GRÜNE": "21681",
    "GRÜNE in %": "11,4",
    "DIE LINKE": "13595",
    "DIE LINKE in %": "7,2",
    "FDP": "13770",
    "FDP in %": "7,3",
    "BFF": "6324",
    "BFF in %": "3,3",
    "PIRATEN": "1349",
    "PIRATEN in %": "0,7",
    "ÖkoLinX-ARL": "3490",
    "ÖkoLinX-ARL in %": "1,8",
    "ELF": "4706",
    "ELF in %": "2,5",
    "REP": "894",
    "REP in %": "0,5",
    "Graue Panther": "666",
    "Graue Panther in %": "0,4",
    "ALFA": "695",
    "ALFA in %": "0,4",
    "IBF": "373",
    "IBF in %": "0,2",
    "Liberale": "393",
    "Liberale in %": "0,2",
    "P.O.P.": "1415",
    "P.O.P. in %": "0,7",
    "FREIE WÄHLER": "469",
    "FREIE WÄHLER in %": "0,2",
    "AfD": "19968",
    "AfD in %": "10,5",
    "NPD": "990",
    "NPD in %": "0,5",
    "DIE PARTEI": "1967",
    "DIE PARTEI in %": "1",
    "dFfm": "1544",
    "dFfm in %": "0,8"
  },
  {
    "Stadtteilnummer": "",
    "Stadtteil": "Stadt insgesamt",
    "Wahlberechtigte insgesamt": "502107",
    "Wähler/innen": "195770",
    "Wähler/innen in %": "39",
    "darunter Wähler mit Wahlschein": "49795",
    "darunter Wähler mit Wahlschein in %": "25,4",
    "gültige Stimmen": "16908244",
    "CDU": "4075690",
    "CDU in %": "24,1",
    "SPD": "4023354",
    "SPD in %": "23,8",
    "GRÜNE": "2583267",
    "GRÜNE in %": "15,3",
    "DIE LINKE": "1356066",
    "DIE LINKE in %": "8",
    "FDP": "1273458",
    "FDP in %": "7,5",
    "BFF": "461066",
    "BFF in %": "2,7",
    "PIRATEN": "142227",
    "PIRATEN in %": "0,8",
    "ÖkoLinX-ARL": "359529",
    "ÖkoLinX-ARL in %": "2,1",
    "ELF": "198490",
    "ELF in %": "1,2",
    "REP": "55118",
    "REP in %": "0,3",
    "Graue Panther": "96825",
    "Graue Panther in %": "0,6",
    "ALFA": "79961",
    "ALFA in %": "0,5",
    "IBF": "69585",
    "IBF in %": "0,4",
    "Liberale": "48516",
    "Liberale in %": "0,3",
    "P.O.P.": "71715",
    "P.O.P. in %": "0,4",
    "FREIE WÄHLER": "94031",
    "FREIE WÄHLER in %": "0,6",
    "AfD": "1508851",
    "AfD in %": "8,9",
    "NPD": "46047",
    "NPD in %": "0,3",
    "DIE PARTEI": "235832",
    "DIE PARTEI in %": "1,4",
    "dFfm": "128616",
    "dFfm in %": "0,8"
  }
]


// WEBPACK FOOTER //
// ./src/data/stv2016stadtteile.js